import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { usersApi } from '@/services/api';

const userKeys = {
  all: ['users'] as const,
  pending: () => [...userKeys.all, 'pending'] as const,
};

// Heroes awaiting an admin decision (with their notes). Admin-only.
export function usePendingUsers() {
  return useQuery({
    queryKey: userKeys.pending(),
    queryFn: () => usersApi.getPendingUsers().then((data) => data.users),
  });
}

export function useApproveUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: string) => usersApi.approveUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.all });
    },
  });
}

export function useRejectUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: string) => usersApi.rejectUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.all });
    },
  });
}
